import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'expense-export-action-renderer',
    templateUrl: './expense-export-action-renderer.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ExpenseExportActionRendererComponent implements ICellRendererAngularComp {
  viewDetailAction = "ViewDetailAction";
  xeroAction = "XeroAction";
  quickBooksAction = "QuickBooksAction";
  params: ICellRendererParams;
  data: any = {};
  param: any;

  onUserAction(action: string) {
    this.params.data.userAction = action;
    this.params.node.setData(this.params.data);
    this.params.eGridCell.click();
  }

  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      this.params = params;
      this.data = params.data;
    } else {
      this.data = {};
    }
  }

  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }
}
